(() => {
    // The snippet can be rendered more than once during cart navigation.
    if (window.manaCartGift) {
        window.manaCartGift.init(document);
        return;
    }

    let addingGift = false;

    function initGiftBox(scope = document) {
        scope.querySelectorAll('[data-gift-select]').forEach((select) => {
            const box = select.closest('.cart-gift-box');
            if (!box) return;

            const option = select.options[select.selectedIndex];
            const button = box.querySelector('[data-gift-button]');
            if (button) {
                button.dataset.id = option?.value || '';
                button.disabled = addingGift || button.dataset.giftAdded === 'true' || !option?.value || option.disabled;
            }
            if (!option) return;

            const placeholder = box.querySelector('[data-gift-placeholder]');
            const image = box.querySelector('[data-gift-image]');
            const link = box.querySelector('[data-gift-url]');
            if (placeholder) placeholder.textContent = option.textContent.trim();
            if (image && option.dataset.image) image.src = option.dataset.image;
            if (link && option.dataset.url) link.href = option.dataset.url;
        });
    }

    window.manaCartGift = { init: initGiftBox };

    document.addEventListener('change', (event) => {
        const select = event.target.closest('[data-gift-select]');
        const box = select?.closest('.cart-gift-box');
        if (box) initGiftBox(box);
    });

    document.addEventListener('click', async (event) => {
        const button = event.target.closest('[data-gift-button]');
        if (!button) return;
        event.preventDefault();
        if (addingGift) return;

        const box = button.closest('.cart-gift-box');
        const select = box?.querySelector('[data-gift-select]');
        // Read the current option even if initialization has not run yet.
        const option = select?.options[select.selectedIndex];
        if (!box || !option?.value || option.disabled) {
            if (box) initGiftBox(box);
            return;
        }

        const errorElement = box.querySelector('[data-gift-error]');
        const fallbackError = box.dataset.errorMessage || 'Unable to add the product. Please try again.';
        const originalLabel = button.textContent;
        const cartRoot = window.Shopify?.routes?.root || '/';
        let added = false;
        addingGift = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = button.dataset.addingLabel || originalLabel;
        if (errorElement) {
            errorElement.hidden = true;
            errorElement.textContent = '';
        }

        try {
            const response = await fetch(`${cartRoot}cart/add.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({
                    id: option.value,
                    quantity: 1,
                    properties: { _gift: 'true', _gift_uid: Date.now().toString() }
                })
            });
            if (!response.ok) {
                const error = await response.json().catch(() => ({}));
                if (errorElement) {
                    errorElement.textContent = typeof error.description === 'string' ? error.description : fallbackError;
                    errorElement.hidden = false;
                }
                return;
            }

            added = true;
            button.dataset.giftAdded = 'true';
            if (typeof window.cartDrawerElement?.refresh === 'function') {
                await window.cartDrawerElement.refresh('mana-cart');
            } else {
                window.location.assign(`${cartRoot}cart`);
            }
        } catch (error) {
            if (added) {
                window.location.assign(`${cartRoot}cart`);
                return;
            }
            if (errorElement) {
                errorElement.textContent = fallbackError;
                errorElement.hidden = false;
            }
            console.error('Unable to add or display the cart gift:', error);
        } finally {
            addingGift = false;
            button.removeAttribute('aria-busy');
            button.textContent = originalLabel;
            // A successful add replaces this box during the cart refresh.
            // Keep its old button disabled to avoid adding the same gift twice.
            initGiftBox(document);
        }
    });

    function start() {
        initGiftBox(document);
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType !== 1) return;
                    if (node.matches?.('.cart-gift-box') || node.querySelector?.('.cart-gift-box')) {
                        initGiftBox(node);
                    }
                });
            });
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
        start();
    }
})();
